export { default } from './FolderIcon';
